import { AxiosReportLas } from '../config';
const TechinicalHoursService = {
  validateLogin: login => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
    });
  },
  sendReport: ({ data, empresa }) => {
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Relatorios/RelatorioHorasTecnicas',
      data,
      headers: {
        headers: {
          'Content-Type': 'application/json',

          EmpresaId: empresa,
        },
      },
    });
  },
};

export { TechinicalHoursService };
